import {localize} from 'commons/LocalizedText/LocalizedText';

export const LocaleText = ({keyName}) => localize(keyName)